import { QueryClient } from '@tanstack/react-query';
import { ENV } from '../lib/env';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: false,
      refetchOnWindowFocus: ENV.isProduction,
    },
  },
});
